import React from "react";
// eslint-disable-next-line no-unused-vars
import * as ButtonTypes from "./Button.types";
import { useStyles } from "./Button.utils";

/**
 * @param {React.ButtonHTMLAttributes<HTMLButtonElement> & ButtonTypes.ButtonProps} props
 */
const Button = (props) => {
  const { children, className, colorVariant = "black", ...buttonProps } = props;
  const defaultStyles = useStyles(colorVariant);

  return (
    <button
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...buttonProps}
      type="button"
      className={`${defaultStyles} ${className || ""}`}
    >
      {children}
    </button>
  );
};

export default Button;